import React, { useState, useEffect, useRef } from "react";

function LoadingElement({ width, onComplete }) {
  const [currentFrame, setCurrentFrame] = useState(0);

  const eggTimerImages = [
    "/egg_loading/egg_pose_1.png",
    "/egg_loading/egg_pose_2.png",
    "/egg_loading/egg_pose_3.png",
    "/egg_loading/egg_pose_4.png",
    "/egg_loading/egg_pose_5.png",
  ];

  const tickSound = useRef(new Audio("/egg_loading/short_tick.mp3"));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFrame((prev) => {
        const nextFrame = (prev + 1) % eggTimerImages.length;

        // Play tick sound on every frame change
        tickSound.current.currentTime = 0;
        tickSound.current.play();

        return nextFrame;
      });
    }, 1000);

    return () => clearInterval(interval);
  });


  return (
    <div style={{ ...styles.container, width: `${width}px`, height: `${width/2}px` }}>
      <img
        src={eggTimerImages[currentFrame]}
        alt="Egg Timer"
        style={styles.image}
      />
      { <p style={styles.text}>Loading ...</p>}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "10px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  text: {
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#FFF",
  },
};

export default LoadingElement;
